import { render, staticRenderFns } from "./BatchSaveLevel.vue?vue&type=template&id=2d5bf66c&"
import script from "./BatchSaveLevel.vue?vue&type=script&lang=js&"
export * from "./BatchSaveLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports